import React from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import { Link } from 'react-router-dom';

// Define options for the component select input
const componentOptions = [
  { value: '', label: 'All', isSelected: true },
  { value: '1', label: 'GUM WORK COMPOSITE' },
  // Add more options here
];

const SalesComponentAccountForm = () => {
  return (
    <div className="summary-form" style={{ maxWidth: '700px',marginTop:"10px", padding: '20px', borderTop: '5px solid #007bff', borderRadius: '0.25rem', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#f8f9fa' }}>
         <h2 className="text-left mb-4 text-dark">Parameters</h2>
      <Form
        action="/lab/reports/view/report/sales-component-account"
        method="get"
        className="report_parameters"
        id="report_sales_component_account"
        acceptCharset="utf-8"
      >
        <Form.Group as={Row} controlId="sales-component-account-start-date">
          <Form.Label column sm={4} title="Please choose a start date to report on">
            Start Date <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              type="date"
              name="start_date"
              required
              defaultValue="2024-09-01"
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="sales-component-account-end-date">
          <Form.Label column sm={4} title="Please choose an end date to report on">
            End Date <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              type="date"
              name="end_date"
              required
              defaultValue="2024-09-30"
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="component_filter">
          <Form.Label column sm={4} style={{ position: 'relative', top: '-7px' }} title="Please choose components to filter the report by">
            Components
          </Form.Label>
          <Col sm={8}>
            <Form.Check
              type="radio"
              label="Include"
              name="component_filter"
              value="include"
              defaultChecked
              style={{ marginRight: '10px' }}
            />
            <Form.Check
              type="radio"
              label="Exclude"
              name="component_filter"
              value="exclude"
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="report_sales_component_account_component">
          <Form.Label column sm={4}>
            Components
          </Form.Label>
          <Col sm={8}>
            <Select
              options={componentOptions}
              name="component[]"
              id="report_sales_component_account_component"
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderRadius: '0.25rem',
                  borderColor: '#ced4da',
                }),
              }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="report_sales_component_account_format">
          <Form.Label column sm={4} title="Please choose a display format">
            Format <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              as="select"
              name="format"
              id="report_sales_component_account_format"
              required
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
                <Col sm={{ span: 8, offset: 4 }}>
                  <Link to="/Addcomponentaccount">
                    <Button
                      id="pay-per-task-submit"
                      type="button"
                      variant="primary"
                      className="w-100 mt-2"
                      style={{
                        backgroundColor: '#004aad',
                        borderColor: '#004aad',
                        marginTop: '10px',
                      }}
                    >
                      Run
                    </Button>
                  </Link>
                </Col>
               </Form.Group>
      </Form>
    </div>
  );
};

export default SalesComponentAccountForm;
